import React, { useEffect } from "react";
import "../../Restrictions/RestrictionsBanner/RestrictionsBanner.css";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const CarRentalServiceBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div className="container-fluid ctm-banner position-relative" style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}>
          <div>
            <img
              src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/car%20rentels.webp"
              alt="Contact Banner"
              className="w-100"
              // For high-speed, use eager loading; for low-speed, lazy loading.
              loading={useHighRes ? "eager" : "lazy"}
              // Attach the onLoad handler only for high-speed connections.
              onLoad={handleImageLoad}
              fetchpriority={useHighRes ? "high" : "auto"}
            />
            {imageLoaded &&
              <div className="ctm-text position-absolute text-white mt-md-5 mt-3">
                <p className="fs4 text-uppercase busy grotesk-headings">
                  GLOBAL TRAVEL
                </p>
                <h1 className="banner-headings w-100">
                  Navigate Travel <br />
                  with Confidence
                </h1>
              </div>
            }
          </div>

          {/* .......................after banner section........................... */}
          {imageLoaded &&
            <div className="container why-staying px-md-5">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="headings">
                    <span>Car Rental </span>Services by Blueberry Travel
                  </h1>
                  <p className="mt-3">
                    At Blueberry Travel, our mission is to revolutionize global
                    business travel by offering top-of-the-line services. Since
                    travel requires transportation services like car rental services
                    as well, whether traveling for work purposes or pleasure, our
                    team will make your experience with car rentals convenient and
                    trouble-free!
                  </p>
                  <p className="mt-3">
                    Blueberry Travel boasts over 10 years of experience offering
                    customized travel management solutions designed to provide
                    maximum return on investment—an asset especially when renting
                    corporate car fleets. Furthermore, we place immense priority on
                    customer safety.
                  </p>
                </div>
              </div>
            </div>
          }
        </div>
      )}
    </BannerWrapper>
  );
};

export default CarRentalServiceBanner;
